import { motion } from "framer-motion";
import { Drama, Vote, Sparkles } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const About = () => {
  const { t } = useI18n();
  const points = [
    { icon: Drama, title: t("about.c1t"), text: t("about.c1x") },
    { icon: Vote, title: t("about.c2t"), text: t("about.c2x") },
    { icon: Sparkles, title: t("about.c3t"), text: t("about.c3x") },
  ];

  return (
    <section id="projet" data-testid="about-section" className="relative py-28 md:py-36 px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-theatre-gold mb-5">{t("about.eyebrow")}</p>
          <h2 className="font-serif text-3xl md:text-5xl text-white leading-tight">{t("about.title")}</h2>
          <div className="mt-6 h-px w-32 gold-hr" />
          <p className="mt-8 text-neutral-300 text-lg leading-relaxed">{t("about.intro")}</p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {points.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              data-testid={`about-card-${i}`}
              className="bg-black/60 backdrop-blur-xl border border-white/10 p-8 hover:border-theatre-gold/40 transition-colors duration-300"
            >
              <p.icon className="text-theatre-gold" size={30} strokeWidth={1.4} />
              <h3 className="mt-6 font-serif text-xl text-white">{p.title}</h3>
              <p className="mt-4 text-sm text-neutral-400 leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
